import { Link, useParams } from 'react-router-dom';
import { formatNewsDate, getNewsArticle } from '../content/news';

export function NewsItem() {
  const { id } = useParams<{ id: string }>();
  const item = id ? getNewsArticle(id) : undefined;

  const prettyDate = formatNewsDate(item?.date);

  return (
    <section className="section">
      <div className="container article-wrap">
        <Link className="back-link reveal" to="/news">
          ← Back to News
        </Link>
        {!item && (
          <div className="news-empty state-panel reveal reveal-delay-1">
            <h3>Article not found</h3>
            <p>We could not find that news item. Visit the News page for the latest updates.</p>
            <p>
              <Link to="/news">Go to News</Link>
            </p>
          </div>
        )}
        {item && (
          <article className="article-card reveal reveal-delay-1">
            <h1>{item.title}</h1>
            {prettyDate && (
              <p className="news-date">
                <small>{prettyDate}</small>
              </p>
            )}
            <div className="prose" dangerouslySetInnerHTML={{ __html: item.contentHtml }} />
          </article>
        )}
      </div>
    </section>
  );
}


